import React, { useEffect, useState } from 'react';
import Rodal from 'rodal';
import { IApplication } from '../types';

export type TCoordinationIssue = {
  curriculum_adaptation: string,
  schedule: string,
};

type Props = {
  show: boolean,
  application: IApplication,
  onClose: () => void,
  onCreate: (issue: TCoordinationIssue) => Promise<void>,
};

const EMPTY: TCoordinationIssue = { curriculum_adaptation: '', schedule: '' };

// Cada campo vira uma seção do e-mail enviado à Coordenação; o que ficar em branco
// não entra.
const FIELDS: { field: keyof TCoordinationIssue, label: string }[] = [
  { field: 'curriculum_adaptation', label: 'Adaptação Curricular' },
  { field: 'schedule', label: 'Grade de Horários' },
];

const CoordinationIssueModal = ({ show, application, onClose, onCreate }: Props) => {
  const [values, setValues] = useState<TCoordinationIssue>(EMPTY);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!show) return;

    setValues(EMPTY);
    setError('');
    setSubmitting(false);
  }, [show]);

  const handleCreate = () => {
    if (FIELDS.every(({ field }) => values[field].trim() === '')) {
      return setError('Descreva a pendência de ao menos um documento.');
    }

    setError('');
    setSubmitting(true);
    onCreate(values).finally(() => setSubmitting(false));
  };

  return (
    <Rodal
      closeOnEsc
      width={600}
      height={560}
      visible={show}
      onClose={onClose}
    >
      <div className="d-flex flex-column h-100">
        <div className="modal-header">
          <div className="text-center">
            <h2>Nova pendência para a Coordenação</h2>
          </div>
        </div>
        <div className="modal-body">
          <p>
            <strong>Inscrição:</strong> #{application.id} - {application.real_name}
          </p>
          <p>A Coordenação recebe um e-mail com as pendências descritas abaixo.</p>
          {FIELDS.map(({ field, label }) => (
            <div className="form-group" key={field}>
              <label htmlFor={`coordination-issue-${field}`}>{label}</label>
              <textarea
                id={`coordination-issue-${field}`}
                className="form-control"
                rows={4}
                disabled={submitting}
                value={values[field]}
                onChange={(event) => setValues({ ...values, [field]: event.target.value })}
              />
            </div>
          ))}
          {error && <small className="text-danger d-block mb-2">{error}</small>}
          <div className="d-flex justify-content-end mt-3">
            <button
              type="button"
              className="btn btn-black"
              onClick={onClose}
              disabled={submitting}
            >
              Cancelar
            </button>
            <button
              id="btn-send-coordination-issue"
              type="button"
              className="btn btn-primary ml-2"
              onClick={handleCreate}
              disabled={submitting}
            >
              {submitting ? 'Enviando...' : 'Enviar pendência'}
            </button>
          </div>
        </div>
      </div>
    </Rodal>
  );
};

export default CoordinationIssueModal;
